module.exports = __webpack_public_path__ + "static/tribute.859904d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/tribute.png
// module id = 470
// module chunks = 246384609461072